export default "images/text.png";